<template>
  <v-layout justify-center>
    <v-flex xs12 md10>
      <v-layout row wrap text-xs-center>
        <v-flex xm12 order-md1 order-xs2>
          <!-- <v-select
            v-model="searchType"
            :items="searchSelect"
            label="Title"
            multiple
            chips
            @change="searchTitles"
          >
            <template v-slot:prepend-item>
              <v-list-tile
                ripple
                @click="toggle"
              >
                <v-list-tile-action>
                  <v-icon :color="searchType.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Select All</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider class="mt-2"></v-divider>
            </template>
          </v-select> -->

          <v-autocomplete
            :items="searchSelect"
            v-model="searchType"
            menu-props="auto"
            label="Title"
            hide-details
            solo
            @change="searchTitles"
          ></v-autocomplete>
        </v-flex>
        <v-flex xm12 order-md3 order-xs3 class="display-1 text-sm-right">
          <v-tooltip bottom>
            <v-btn fab outline small color="primary" @click="buildEmail()" slot="activator" :disabled="!selected">
              <v-icon dark>email</v-icon>
            </v-btn>
            <span>Email Selected</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn fab outline small color="primary" @click="buildText()" slot="activator" :disabled="!selected">
              <v-icon dark>message</v-icon>
            </v-btn>
            <span>Text Selected</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn fab outline small color="error" v-if="isAdmin" to="/election" slot="activator">
              <v-icon>how_to_vote</v-icon>
            </v-btn>
            <span>Election</span>
          </v-tooltip>
          <v-menu offset-y>
            <v-btn v-if="isAdmin" slot="activator" icon>
              <v-icon>more_vert</v-icon>
            </v-btn>
            <v-list dense>
              <v-list-tile v-on:click="onExport" :disabled="!selected">
                <v-list-tile-action>
                <v-icon :disabled="!selected">cloud_download</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>Member List</v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-on:click="onExportConflict" :disabled="!selected">
                <v-list-tile-action>
                <v-icon :disabled="!selected">cloud_download</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>Director Conflicts (Select Directors)</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click.stop="onExportComm">
                <v-list-tile-action>
                <v-icon>cloud_download</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>Members Committees</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click.stop="onExportTitle">
                <v-list-tile-action>
                <v-icon>cloud_download</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>Members Titles</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click.stop="onExportBadge">
                <v-list-tile-action>
                <v-icon>cloud_download</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>Badge List</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click.stop="onExportEvals">
                <v-list-tile-action>
                <v-icon>cloud_download</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>Evaluation List</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click.stop="onExportHandbook">
                <v-list-tile-action>
                <v-icon>cloud_download</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>Handbook List</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-flex>
      </v-layout>

      <vue-good-table
        ref="my-table"
        styleClass="vgt-table striped bordered"
        :max-height=this.height
        :fixed-header="true"
        :columns="columns"
        :isLoading=this.isTableLoading
        :rows="rows"
        @on-cell-click="onCellClick"
        :select-options="{
          enabled: true,
          selectOnCheckboxOnly: true
        }"
        :search-options="{
          enabled: true,
          skipDiacritics: true
        }"
        :pagination-options="{
        enabled: true,
        mode: 'pages',
        perPageDropdown: [10, 20, 50]
      }">
        <template slot="loadingContent">
          <div>
            <v-progress-circular
              :size="50"
              :width="7"
              color="blue"
              indeterminate
            ></v-progress-circular>
          </div>
        </template>
        <div slot="table-actions">
          <v-switch label="Include All" v-model="searchAll"></v-switch>
        </div>
        <div slot="table-actions-bottom">
          <span class="body-2" style="padding-left: 20px;">Number of records: {{ totalCount }}</span>
        </div>
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'fullName'">
            <v-layout align-center justify-start row fill-height>
              <v-flex sm3 lg2>
                <v-avatar
                  slot="activator"
                  size="52px"
                  color="indigo"
                >
                  <img v-if="props.row.image" :src="props.row.picture" :lazy-src="props.row.picture" alt="Avatar" />
                  <span v-else class="white--text headline">{{ props.row.firstName.substr(0, 1) }}{{ props.row.lastName.substr(0, 1) }}</span>
                </v-avatar>
              </v-flex>
              <v-flex sm9 lg10>
                <div style="font-weight: bold;">{{ props.row.fullName }} <span v-if="props.row.birthDate > minorDate" class="red--text">(Minor)</span><br/>({{ props.row.Title.name }})</div>
              </v-flex>
            </v-layout>
          </span>
          <span v-else-if="props.column.field == 'email'">
            <v-layout justify-start row fill-height>
              <v-flex xs12 style="text-align: center;">
                <a :href="'mailto:' + props.row.email" style="text-decoration: none;">
                  <v-tooltip bottom>
                    <v-icon slot="activator">email</v-icon>
                    <span>{{ props.row.email }}</span>
                  </v-tooltip>
                </a>
              </v-flex>
            </v-layout>
          </span>
          <span v-else-if="props.column.field == 'actions'">
            <v-avatar
              color="blue lighten-4"
              class="mr-2 mt-2"
              size="30"
              style="cursor: pointer;"
              @click="editItem(props)"
            >
              <v-icon small>edit</v-icon>
            </v-avatar>
          </span>
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
      </vue-good-table>
    </v-flex>

    <v-btn
      v-if="isAdmin"
      fab
      bottom
      right
      color="blue"
      dark
      fixed
      class="add-button-bottom"
      @click.stop="newItem"
    >
      <v-icon>person_add</v-icon>
    </v-btn>

    <v-dialog v-model="viewDialog" max-width="500px">
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 md6 order-xs2 order-md1>
                <v-flex xs12 class="text-xs-center text-sm-center">
                  <span class="headline">{{ editedItem.name }}</span><br />
                  <span class="subheading">({{ editedItem.title }})</span><br />
                  <div v-if="editedItem.birthDate <= minorDate">{{ editedItem.address }}<br />
                  {{ editedItem.city }}, {{ editedItem.state }} {{ editedItem.zip }}</div>
                </v-flex>
                <v-flex xs12>
                  <v-btn
                    v-if="editedItem.email && editedItem.birthDate <= minorDate"
                    block
                    color="blue-grey"
                    class="white--text"
                    :href="sendEmail"
                  >
                    Email {{editedItem.firstName}}
                    <v-icon right dark>email</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="editedItem.cellPhone && editedItem.birthDate <= minorDate"
                    block
                    color="blue-grey"
                    class="white--text"
                    :href="callMobile"
                  >
                    Call Mobile
                    <v-icon right dark>mobile_screen_share</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="editedItem.homePhone && editedItem.birthDate <= minorDate"
                    block
                    color="blue-grey"
                    class="white--text"
                    :href="callHome"
                  >
                    Call Home
                    <v-icon right dark>phone</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="editedItem.workPhone && editedItem.birthDate <= minorDate"
                    block
                    color="blue-grey"
                    class="white--text"
                    :href="callWork"
                  >
                    Call Work
                    <v-icon right dark>business</v-icon>
                  </v-btn>
                  <v-btn
                    block
                    v-if="editedItem.birthDate <= minorDate"
                    color="blue-grey"
                    class="white--text"
                    @click="getVCard()"
                  >
                    Download Contact
                  </v-btn>
                </v-flex>
                  <span class="headline">{{ currentYear }} Committees</span><br />
                  <v-list>
                    <v-list-tile
                      v-for="item in currentCommittees"
                      :key="item.id"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title v-text="item.name"></v-list-tile-title>
                        <v-list-tile-sub-title>{{ item.title }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              <v-flex xs12 md6 order-xs1 order-md2 class="text-xs-center text-sm-center text-md-center text-lg-center">
                <img :src="editedItem.picture" height="150" v-if="editedItem.image"/>
                <v-icon v-else x-large color="blue">person</v-icon>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <UserForm
      :visible="showUserForm"
      :item="editedItem"
      :isEdit="isEdit"
      :isOpen="isOpen"
      @close="closeThis"
      @saveUser="handleSaveUser"
    />

    <EmailForm
      :visible="showEmailForm"
      :items="emailList"
      :selectedItems="emails"
      @close="closeThis"
    />

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import UserForm from './forms/UserForm'
import EmailForm from './forms/EmailForm'
import moment from 'moment'
import XLSX from 'xlsx'

export default {
  components: {
    VueGoodTable,
    UserForm,
    EmailForm
  },
  data () {
    return {
      currentPage: 'Members',
      currentYear: 0,
      isAdmin: false,
      searchSelect: [
        { text: 'All Active', value: '' },
        { text: 'Directors', value: 'Director' },
        { text: 'Past Presidents', value: 'Past President' },
        { text: 'Directors/Past Presidents', value: 'Director-Past President' },
        { text: 'Members', value: 'Member' },
        { text: 'Directors/Past Presidents/Members', value: 'Director-Past President-Member' },
        { text: 'Wranglers', value: 'Wrangler' },
        { text: 'Director Emeritus', value: 'Dir Emr' },
        { text: 'Member Emeritus', value: 'Mem Emr' },
        { text: 'All Emeritus', value: 'Dir Emr-Mem Emr' },
        { text: 'Queens', value: 'Queen' },
        { text: 'Honorary Members', value: 'Hon Mem' },
        { text: 'Associates', value: 'Associate' },
        { text: 'Inactive', value: 'Inactive' },
        { text: 'Partner', value: 'Partner' },
        { text: 'New Wrangler', value: 'New Wrangler' }
      ],
      searchType: [],
      showUserForm: false,
      showEmailForm: false,
      isEdit: false,
      isOpen: true,
      viewDialog: false,
      isTableLoading: false,
      isMounted: false,
      searchAll: false,
      minorDate: '',
      sendEmail: '',
      callMobile: '',
      callHome: '',
      callWork: '',
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      editedIndex: -1,
      height: 0,
      columns: [
        {
          label: 'Name',
          field: 'fullName',
          thClass: 'text-center',
          html: true
        },
        {
          label: 'Email',
          field: 'email',
          thClass: 'hidden-sm-and-down email-width text-center',
          tdClass: 'hidden-sm-and-down email-width',
          html: true
        },
        {
          label: 'Mobile',
          field: 'cellPhone',
          thClass: 'hidden-sm-and-down text-center',
          tdClass: 'hidden-sm-and-down',
          type: 'text'
        },
        {
          label: 'Status',
          field: 'Title.name',
          thClass: 'hidden-lg-and-down hidden-sm-and-up text-center',
          tdClass: 'hidden-lg-and-down hidden-sm-and-up',
          type: 'text'
        },
        {
          label: 'Action',
          field: 'actions',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false,
          hidden: true,
          html: true,
          width: '60px'
        }
      ],
      rows: [],
      printMembers: {},
      editedItem: {
        index: 0,
        id: 0,
        name: '',
        title: '',
        firstName: '',
        image: '',
        picture: '',
        imageFile: '',
        email: '',
        cellPhone: '',
        homePhone: '',
        workPhone: '',
        count: 0
      },
      defaultItem: {
        index: 0,
        id: 0,
        name: '',
        title: '',
        firstName: '',
        image: '',
        picture: '',
        imageFile: '',
        email: '',
        cellPhone: '',
        homePhone: '',
        workPhone: '',
        count: 0
      },
      emails: [],
      mobileTypes: [],
      cc: [],
      bcc: [],
      emailList: [],
      ccList: [],
      bccList: [],
      emailText: '',
      currentCommittees: []
    }
  },

  created () {
    this.isTableLoading = true
    this.$store.dispatch('setCurrentPage', this.currentPage)
    this.currentYear = this.$store.state.currentYear

    if (this.$store.state.isAdmin) {
      this.isAdmin = true
    } else {
      this.isAdmin = this.$store.state.controls.includes('Users')
    }

    if (this.isAdmin) {
      this.columns[this.columns.length - 1].hidden = false
    }

    let minorDate = moment()
    minorDate = minorDate.subtract(21, 'years')
    this.minorDate = moment(minorDate).format('YYYY-MM-DD')

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getItems()
    this.getMobiles()
    // this.isTableLoading = false
  },

  mounted () {
    this.isMounted = true
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },

    selected () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].selectedRowCount > 0
    },

    totalCount () {
      if (!this.isMounted) {
        return
      }

      return this.$refs['my-table'].totalRowCount
    },
    likesAllFruit () {
      return this.searchType.length === this.searchSelect.length
    },
    likesSomeFruit () {
      return this.searchType.length > 0 && !this.likesAllFruit
    },
    icon () {
      if (this.likesAllFruit) return 'mdi-close-box'
      if (this.likesSomeFruit) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    }
  },

  watch: {
    searchAll () {
      this.isTableLoading = true
      this.getItems()
    }
  },

  methods: {
    toggle () {
      this.$nextTick(() => {
        if (this.likesAllFruit) {
          this.searchType = []
        } else {
          this.searchType = this.searchSelect.slice()
        }
      })
    },

    async searchTitles () {
      if (this.searchType) {
        try {
          const response = await Api().get('users_by_title/' + this.searchType)
          this.rows = response.data
          this.isTableLoading = false
        } catch (error) {
          this.error = error.response.data.error
        }
      } else {
        let allUsers = 'users'

        if (this.searchAll) {
          allUsers = 'all_users'
        }

        try {
          const response = await Api().get(allUsers)
          this.rows = response.data
          this.isTableLoading = false
        } catch (error) {
          this.error = error.response.data.error
        }
      }
    },

    async getVCard () {
      try {
        const response = await Api().get('get_vcard/' + this.editedItem.id)

        let blob = new Blob([response.data], { type: 'text/vcard' })
        let url = window.URL.createObjectURL(blob)

        window.open(url)
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    handleResize () {
      const height = window.innerHeight - 300
      this.height = height + 'px'
    },

    async onCellClick (params) {
      try {
        if (params.column.field === 'fullName') {
          this.editedItem.id = params.row.id
          this.editedItem.name = params.row.fullName
          this.editedItem.title = params.row.Title.name
          this.editedItem.firstName = params.row.firstName
          this.editedItem.address = params.row.address1
          this.editedItem.city = params.row.city
          this.editedItem.state = params.row.state
          this.editedItem.zip = params.row.zip
          this.editedItem.email = params.row.email
          this.editedItem.cellPhone = params.row.cellPhone
          this.editedItem.homePhone = params.row.homePhone
          this.editedItem.workPhone = params.row.workPhone
          this.sendEmail = 'mailto:' + params.row.email
          this.callMobile = 'tel:' + params.row.cellPhone
          this.callHome = 'tel:' + params.row.homePhone
          this.callWork = 'tel:' + params.row.workPhone
          this.editedItem.image = params.row.image
          this.editedItem.picture = params.row.picture
          this.editedItem.birthDate = params.row.birthDate

          const response = await Api().get('users_committees/' + params.row.id)
          const userDetail = response.data

          const userCommittees = userDetail.map(a => ({
            id: a.id,
            name: a.name,
            title: a.title,
            year: a.year
          }))
          console.log('comm', userCommittees)

          this.currentCommittees = userCommittees.filter(obj => {
            return obj.year === this.currentYear
          })

          this.viewDialog = true
        }
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
      // params.row - row object
      // params.column - column object
      // params.rowIndex - index of this row on the current page.
      // params.event - click event
    },

    newItem () {
      this.isEdit = false
      this.showUserForm = true
    },

    buildEmail () {
      for (let i in this.rows) {
        this.emailList[i] = this.rows[i].email
      }
      this.ccList = this.emailList
      this.bccList = this.emailList

      for (let i in this.$refs['my-table'].selectedRows) {
        this.emails[i] = this.$refs['my-table'].selectedRows[i].email
      }

      this.showEmailForm = true

      if (this.emails.length > 9) {
        this.emailText = 'You are sending to ' + this.emails.length + ' email addresses'
        this.editTo = false
      } else {
        this.emailText = ''
        this.editTo = true
      }
    },

    buildText () {
      for (let i in this.$refs['my-table'].selectedRows) {
        // console.log(this.$refs['my-table'].selectedRows[i])

        if (this.$refs['my-table'].selectedRows[i].MobileTypeId >= 1) {
          let mobileType = this.mobileTypes.filter(obj => {
            return obj.id === this.$refs['my-table'].selectedRows[i].MobileTypeId
          })

          // console.log('type', mobileType[0].extension)

          let phone = this.$refs['my-table'].selectedRows[i].cellPhone.replace(/[^+\d]+/g, '')
          this.emails[i] = phone + mobileType[0].extension
        }
      }

      this.showEmailForm = true

      if (this.emails.length > 9) {
        this.emailText = 'You are sending to ' + this.emails.length + ' email addresses'
        this.editTo = false
      } else {
        this.emailText = ''
        this.editTo = true
      }
    },

    closeThis (item) {
      console.log('test')
      this.emails = []
      this.showUserForm = false
      this.showEmailForm = false
    },

    handleSaveUser (item) {
      console.log('item', item)
      this.showUserForm = false
      this.getItems()

      // console.log(item)
    },

    editItem (props) {
      console.log('props', props)
      this.editedItem = props.row
      this.editedItem.index = props.index
      this.editedItem.password = ''
      // this.editedItem.diet = props.formattedRow.diet
      // this.editedItem.count = props.formattedRow.count
      // this.editedItem.image = props.row.image
      // this.editedItem.picture = props.row.picture
      this.isEdit = true
      this.showUserForm = true
      // this.dialog = true
    },

    save () {
      if (this.editedIndex > -1) {
        // console.log('Update')
        this.updateItem(this.editedItem)
      } else {
        // console.log('Save')
        this.rows.push(this.editedItem)
        this.addItem(this.editedItem)
      }

      this.close()
    },

    deleteItem () {
      let r = confirm('Are you sure you want to delete ' + this.editedItem.name + '?')

      if (r === true) {
        this.rows.splice(this.editedIndex, 1)
        this.removeItem(this.editedItem.id)
      }

      this.close()
    },

    deleteItemList (props) {
      let r = confirm('Are you sure you want to delete ' + props.formattedRow.name + '?')

      if (r === true) {
        this.rows.splice(props.index, 1)
        this.removeItem(props.row.id)
      }
    },

    async getItems () {
      let allUsers = 'users'

      if (this.searchAll) {
        allUsers = 'all_users'
      }

      try {
        const response = await Api().get(allUsers)
        console.log('get items')
        this.rows = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async getMobiles () {
      try {
        const response = await Api().get('get_mobiles')
        console.log('Mobiles', response.data)
        this.mobileTypes = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async addItem (item) {
      let formData = new FormData()
      formData.append('name', item.name)
      formData.append('diet', item.diet)
      formData.append('image', item.image)
      formData.append('count', item.count)
      formData.append('imageFile', item.imageFile)

      try {
        const response = await Api().post('animals', formData)
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateItem (item) {
      let formData = new FormData()
      formData.append('name', item.name)
      formData.append('diet', item.diet)
      formData.append('image', item.image)
      formData.append('count', item.count)
      formData.append('imageFile', item.imageFile)

      try {
        const response = await Api().put('animals/' + item.id, formData)
        this.editedItem.image = response.data.body.image
        Object.assign(this.rows[this.editedIndex], this.editedItem)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async removeItem (itemId) {
      try {
        const response = await Api().delete('animals/' + itemId)
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    close () {
      // this.dialog = false
      this.viewDialog = false

      // setTimeout(() => {
      //   this.editedItem = Object.assign({}, this.defaultItem)
      //   this.editedIndex = -1
      // }, 300)
    },

    onExport () {
      this.printMembers = this.rows.map(a => ({
        'Id': a.id,
        'First Name': a.firstName,
        'Last Name': a.lastName,
        'Title': a.Title.name,
        'Address': a.address1,
        'City': a.city,
        'State': a.state,
        'Zip': a.zip,
        'Email': a.email,
        'Mobile': a.cellPhone,
        'BirthDay': a.birthDate,
        'Home Phone': a.homePhone,
        'Work Phone': a.workPhone
      }))

      let membersWS = XLSX.utils.json_to_sheet(this.printMembers)

      let wb = XLSX.utils.book_new()

      if (!wb.Props) { wb.Props = {} }
      wb.Props.Title = 'Member List'

      XLSX.utils.book_append_sheet(wb, membersWS, 'Members')

      XLSX.writeFile(wb, 'members.xlsx')
    },

    onExportConflict () {
      this.printMembers = this.rows.map(a => ({
        'Id': a.id,
        'First Name': a.firstName,
        'Last Name': a.lastName,
        'Full Name': a.cFullName,
        'Conflict': a.conflict,
        'Organization 1': a.cName1,
        'Position 1': a.cPosition1,
        'Whom 1': a.cWhom1,
        'Organization 2': a.cName2,
        'Position 2': a.cPosition2,
        'Whom 2': a.cWhom2,
        'Organization 3': a.cName3,
        'Position 3': a.cPosition3,
        'Whom 3': a.cWhom3,
        'When': a.cDate
      }))

      let membersWS = XLSX.utils.json_to_sheet(this.printMembers)

      let wb = XLSX.utils.book_new()

      if (!wb.Props) { wb.Props = {} }
      wb.Props.Title = 'Director Conflict'

      XLSX.utils.book_append_sheet(wb, membersWS, 'directors')

      XLSX.writeFile(wb, 'directors.xlsx')
    },

    async onExportComm () {
      try {
        const response = await Api().get('allusers_committees/' + this.currentYear)

        // console.log('rows', this.rows)
        const committees = response.data
        let printArray = []
        let printItem = {}

        for (let i in this.rows) {
          printItem['Id'] = this.rows[i].id
          printItem['Name'] = this.rows[i].fullName
          printItem['Title'] = this.rows[i].Title.name
          printItem['Email'] = this.rows[i].email
          printItem['Mobile'] = this.rows[i].cellPhone
          printItem['Home Phone'] = this.rows[i].homePhone
          printItem['Work Phone'] = this.rows[i].workPhone
          printItem['Start Year'] = this.rows[i].startDate
          printItem['Created Date'] = this.rows[i].createdAt

          const results = committees.filter(obj => {
            return obj.id === this.rows[i].id
          })

          if (results.length > 0) {
            let k = 1
            for (let j in results) {
              printItem['Comm' + k] = results[j].name + ' (' + results[j].title + ')'
              k++
            }
          }
          printArray.push(printItem)
          printItem = {}
        }

        let membersWS = XLSX.utils.json_to_sheet(printArray)

        let wb = XLSX.utils.book_new()

        if (!wb.Props) { wb.Props = {} }
        wb.Props.Title = 'Member List'

        XLSX.utils.book_append_sheet(wb, membersWS, 'Members Committeess')

        XLSX.writeFile(wb, 'members_committees.xlsx')
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async onExportTitle () {
      try {
        const response = await Api().get('allusers_titles')

        // console.log('rows', this.rows)
        const titles = response.data
        let printArray = []
        let printItem = {}

        for (let i in this.rows) {
          printItem['Id'] = this.rows[i].id
          printItem['Name'] = this.rows[i].fullName
          printItem['Title'] = this.rows[i].Title.name
          printItem['Email'] = this.rows[i].email
          printItem['Mobile'] = this.rows[i].cellPhone
          printItem['Home Phone'] = this.rows[i].homePhone
          printItem['Work Phone'] = this.rows[i].workPhone

          const results = titles.filter(obj => {
            return obj.id === this.rows[i].id
          })

          if (results.length > 0) {
            let k = 1
            for (let j in results) {
              printItem['Title' + k] = results[j].name
              printItem['Date' + k] = results[j].niceDate
              k++
            }
          }
          printArray.push(printItem)
          printItem = {}
        }

        let membersWS = XLSX.utils.json_to_sheet(printArray)

        let wb = XLSX.utils.book_new()

        if (!wb.Props) { wb.Props = {} }
        wb.Props.Title = 'Member List'

        XLSX.utils.book_append_sheet(wb, membersWS, 'Members Titles')

        XLSX.writeFile(wb, 'members_titles.xlsx')
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async onExportHandbook () {
      try {
        let printArray = []
        let printItem = {}

        for (let i in this.rows) {
          let handbook = 'No'
          let handBookDate = {}

          if (this.rows[i].handBook === true) {
            handbook = 'Yes'

            const response = await Api().get('handbook/' + this.rows[i].email + '/' + this.currentYear)

            if (response.data.length > 0) {
              handBookDate = response.data[0]
              console.log('date', handBookDate.createdAt)
            }
          }

          printItem['Id'] = this.rows[i].id
          printItem['First Name'] = this.rows[i].firstName
          printItem['Last Name'] = this.rows[i].lastName
          printItem['Title'] = this.rows[i].Title.name
          printItem['Updated'] = handBookDate.createdAt
          printItem['Handbook'] = handbook

          printArray.push(printItem)
          printItem = {}
        }

        let membersWS = XLSX.utils.json_to_sheet(printArray)

        let wb = XLSX.utils.book_new()

        if (!wb.Props) { wb.Props = {} }
        wb.Props.Title = 'Member Handbook'

        XLSX.utils.book_append_sheet(wb, membersWS, 'Members Handbook')

        XLSX.writeFile(wb, 'members_handbook.xlsx')
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async onExportBadge () {
      try {
        const response = await Api().get('badges/' + this.currentYear)

        const badges = response.data
        console.log('badges', badges)
        let printArray = []
        let printItem = {}

        for (let i in badges) {
          printItem['Id'] = badges[i].id
          printItem['First Name'] = badges[i].firstName
          printItem['Last Name'] = badges[i].lastName
          printItem['Image'] = badges[i].image
          printItem['Star'] = badges[i].star
          printItem['Status'] = badges[i].status
          printItem['Title'] = badges[i].title

          printArray.push(printItem)
          printItem = {}
        }

        let membersWS = XLSX.utils.json_to_sheet(printArray)

        let wb = XLSX.utils.book_new()

        if (!wb.Props) { wb.Props = {} }
        wb.Props.Title = 'Member Badges'

        XLSX.utils.book_append_sheet(wb, membersWS, 'Members Badges')

        XLSX.writeFile(wb, 'members_badges.xlsx')
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async onExportEvals () {
      try {
        let currentDate = moment().format('YYYY-MM-DD')
        let theDate = moment().toObject()
        let currentYear = null

        console.log(currentDate)
        // if (currentDate >= theDate.years + '-07-01' &&
        //   currentDate < theDate.years + '-08-01'
        // ) {
        //   currentYear = this.currentYear - 1
        // } else {
          currentYear = this.currentYear
        // }
        console.log(currentYear)

        const response = await Api().get('year_evals/' + currentYear)

        const evals = response.data.evals
        console.log('evals', evals)
        let printArray = []
        let printItem = {}

        for (let i in evals) {
          printItem['Committee'] = evals[i].committee
          printItem['First Name'] = evals[i].firstName
          printItem['Last Name'] = evals[i].lastName
          printItem['Title'] = evals[i].title
          printItem['Evaluator'] = evals[i].evalName

          if (evals[i].attitudeWork === 4) {
            printItem['Leadership'] = 'Top Hand'
          } else if (evals[i].attitudeWork === 3) {
            printItem['Leadership'] = 'Exceeds Expectations'
          } else if (evals[i].attitudeWork === 2) {
            printItem['Leadership'] = 'Meets Expectations'
          } else if (evals[i].attitudeWork === 1) {
            printItem['Leadership'] = 'Needs Improvement'
          }

          if (evals[i].attitudeRodeo === 4) {
            printItem['Knowledge of Position/Committee'] = 'Top Hand'
          } else if (evals[i].attitudeRodeo === 3) {
            printItem['Knowledge of Position/Committee'] = 'Exceeds Expectations'
          } else if (evals[i].attitudeRodeo === 2) {
            printItem['Knowledge of Position/Committee'] = 'Meets Expectations'
          } else if (evals[i].attitudeRodeo === 1) {
            printItem['Knowledge of Position/Committee'] = 'Needs Improvement'
          }

          if (evals[i].locGuests === 4) {
            printItem['Quality of Work'] = 'Top Hand'
          } else if (evals[i].locGuests === 3) {
            printItem['Quality of Work'] = 'Exceeds Expectations'
          } else if (evals[i].locGuests === 2) {
            printItem['Quality of Work'] = 'Meets Expectations'
          } else if (evals[i].locGuests === 1) {
            printItem['Quality of Work'] = 'Needs Improvement'
          }

          if (evals[i].locCommembers === 4) {
            printItem['Dependability'] = 'Top Hand'
          } else if (evals[i].locCommembers === 3) {
            printItem['Dependability'] = 'Exceeds Expectations'
          } else if (evals[i].locCommembers === 2) {
            printItem['Dependability'] = 'Meets Expectations'
          } else if (evals[i].locCommembers === 1) {
            printItem['Dependability'] = 'Needs Improvement'
          }

          if (evals[i].locComleaders === 4) {
            printItem['Interpersonal Relationship'] = 'Top Hand'
          } else if (evals[i].locComleaders === 3) {
            printItem['Interpersonal Relationship'] = 'Exceeds Expectations'
          } else if (evals[i].locComleaders === 2) {
            printItem['Interpersonal Relationship'] = 'Meets Expectations'
          } else if (evals[i].locComleaders === 1) {
            printItem['Interpersonal Relationship'] = 'Needs Improvement'
          }

          if (evals[i].profOntime === 4) {
            printItem['Personal Qualities'] = 'Top Hand'
          } else if (evals[i].profOntime === 3) {
            printItem['Personal Qualities'] = 'Exceeds Expectations'
          } else if (evals[i].profOntime === 2) {
            printItem['Personal Qualities'] = 'Meets Expectations'
          } else if (evals[i].profOntime === 1) {
            printItem['Personal Qualities'] = 'Needs Improvement'
          }

          printItem['Comments'] = evals[i].notes
          printItem['Hours'] = evals[i].hours

          if (evals[i].award === 1) {
            printItem['Award'] = 'Yes'
            printItem['Award Type'] = evals[i].awardType
          } else {
            printItem['Award'] = 'No'
            printItem['Award Type'] = ''
          }

          printItem['Award Notes'] = evals[i].awardNotes

          if (evals[i].excussed === 1) {
            printItem['Excused'] = 'Yes'
            printItem['Excused Notes'] = evals[i].excussedNotes
          } else {
            printItem['Excused'] = 'No'
            printItem['Excused Notes'] = ''
          }

          if (evals[i].membership === 1) {
            printItem['Membership'] = 'Yes'
          } else {
            printItem['Membership'] = 'No'
          }

          if (evals[i].noWork === 1) {
            printItem['Did not work'] = 'Yes'
          } else {
            printItem['Did not work'] = 'No'
          }

          if (evals[i].drop === 1) {
            printItem['Dropped'] = 'Yes'
            printItem['Dropped Notes'] = evals[i].dropNotes
          } else {
            printItem['Dropped'] = 'No'
            printItem['Dropped Notes'] = ''
          }

          printArray.push(printItem)
          printItem = {}
        }

        let membersWS = XLSX.utils.json_to_sheet(printArray)

        let wb = XLSX.utils.book_new()

        if (!wb.Props) { wb.Props = {} }
        wb.Props.Title = 'Member Evals'

        XLSX.utils.book_append_sheet(wb, membersWS, 'Members Evals')

        XLSX.writeFile(wb, 'members_evals.xlsx')
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<style>
.vgt-fixed-header {
  z-index: 1;
}

.vgt-fixed-header th:last-child {
  width: calc(100% + 17px) !important;
}

.email-width {
  max-width: 100px;
}
.text-center {
  text-align: center;
}

.v-input--selection-controls {
  margin-top: 0;
  padding-right: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/Users.vue